/* eslint-disable no-useless-escape */
import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, Button, Typography, Modal, Grid, CircularProgress } from '@mui/material';
import { Close, MailOutline } from '@mui/icons-material/';
import { Colors } from '../config/default';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../richTextEditor.css';
import { sendEmailToVendor } from '../services/services';
import { useParams } from 'react-router-dom';
import { useToast } from '../toast/toastContext';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '55vw',
  bgcolor: Colors.NAV_BLACK,
  boxShadow: 24,
  p: 3,
  borderRadius: '10px'
};

export default function EmailVendor() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [richText, setRichText] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [loading, setLoading] = useState(false);
  const [documentId, setDocumentId] = useState('');
  const { id } = useParams();
  const { showToast } = useToast();

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'bullet' }, { list: 'ordered' }],
      ['align', { align: 'center' }, { align: 'right' }],
      ['link']
    ]
  };

  useEffect(() => {
    setDocumentId(id);
  }, [id]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };
  const handleChange = (content, delta, source, editor) => {
    setRichText(editor.getHTML());
  };

  const isButtonDisabled =
    !email.trim() ||
    !email.includes('@') ||
    !email.includes('.com') ||
    !subject.trim() ||
    !richText.replace(/<\/?[^>]+(>|$)/g, '').trim();

  const apiData = {
    emailContent: richText
      .replace('class="ql-align-center"', 'style=text-align:center;')
      .replace(/class=\"ql-align-center\"/g, 'style=text-align:center;')
      .replace('class="ql-align-right"', 'style=text-align:right;')
      .replace(/class="ql-align-right"/g, 'style=text-align:right;'),
    subject,
    sendTo: email,
    documentId: documentId
  };

  const handleClick = async () => {
    setLoading(true);
    const res = await sendEmailToVendor(apiData);
    if (res?.status === 200) {
      showToast(res?.data?.metadata?.message, 'success');
      setLoading(false);
      setOpen(false);
      setRichText('');
      setEmail('');
      setSubject('');
    } else {
      setLoading(false);
      showToast(res?.data?.metadata?.message || res?.response?.data?.metadata?.message, 'error');
    }
  };

  return (
    <div>
      <Button
        variant="outlined"
        onClick={handleOpen}
        sx={{
          fontSize: '.8em',
          textTransform: 'none',
          borderRadius: '10px',
          width: '8rem',
          height: '2rem',
          color: Colors.WHITE,
          marginRight: '1rem',
          '&:disabled': {
            color: 'gray',
            cursor: 'not-allowed'
          },
          '&:hover': {
            background: 'none'
          }
        }}
        startIcon={
          <MailOutline
            sx={{
              color: Colors.DARKBLUE
            }}
          />
        }>
        Send Email
      </Button>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Grid container>
            <Grid xs={11} sx={{ paddingLeft: '4.5em' }}>
              <Typography sx={{ textAlign: 'center', color: Colors.WHITE, fontSize: '1.25rem' }}>
                Send Email
              </Typography>
            </Grid>
            <Grid xs={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Close
                onClick={handleClose}
                sx={{ fontSize: '1.5rem', color: Colors.LIGHTGREY, cursor: 'pointer' }}
              />
            </Grid>
          </Grid>
          <Grid
            xs={12}
            sx={{
              mt: '2em'
            }}>
            <input
              onChange={handleEmailChange}
              value={email}
              type="text"
              style={{
                width: '96%',
                backgroundColor: 'transparent',
                outline: 'none',
                border: '1px solid #636363',
                padding: '16px 2%',
                color: Colors.WHITE,
                borderRadius: '10px'
              }}
              placeholder="To"
            />
          </Grid>
          <Grid xs={12} sx={{ mt: '1em' }}>
            <input
              onChange={handleSubjectChange}
              value={subject}
              type="text"
              style={{
                width: '96%',
                backgroundColor: 'transparent',
                outline: 'none',
                border: '1px solid #636363',
                padding: '16px 2%',
                color: Colors.WHITE,
                borderRadius: '10px'
              }}
              placeholder="Subject"
            />
          </Grid>
          <Grid xs={12} sx={{ mt: '1em' }}>
            <ReactQuill
              style={{
                width: '100%',
                height: '33vh',
                color: Colors.WHITE
              }}
              className="richText"
              value={richText}
              onChange={handleChange}
              modules={modules}
            />
          </Grid>
          <Grid xs={12} container sx={{ justifyContent: 'center', mt: '4em' }}>
            <Button
              onClick={handleClick}
              disabled={isButtonDisabled}
              variant="contained"
              sx={{
                color: Colors.WHITE,
                width: '8rem',
                height: '2.2rem',
                fontSize: '16px',
                textTransform: 'none',
                backgroundColor: '#24658D',
                borderRadius: '10px',
                '&:hover': {
                  background: '#24658D'
                }
              }}>
              {loading ? (
                <Grid container sx={{ alignItems: 'center', justifyContent: 'center' }}>
                  <CircularProgress size={18} sx={{ color: Colors.DARKBLUE }} />
                </Grid>
              ) : (
                'Send'
              )}
            </Button>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
